/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treat it as a guide. Body composition, waist size and how you feel matter more than hitting a formula's number.`)
};

const es_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trátalo como una guía. La composición corporal, el tamaño de la cintura y cómo te sientes importan más que alcanzar el número de una fórmula.`)
};

const de_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrachte es als Orientierung. Körperzusammensetzung, Taillenumfang und dein persönliches Wohlbefinden zählen mehr als das exakte Erreichen eines Formelwerts.`)
};

const nl_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zie het als richtlijn. Lichaamssamenstelling, tailleomvang en hoe je je voelt zijn belangrijker dan het exacte getal van een formule.`)
};

const fr_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Considérez-le comme un guide. La composition corporelle, le tour de taille et votre ressenti comptent plus que d'atteindre le chiffre d'une formule.`)
};

const it_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Considerala un'indicazione. Composizione corporea, girovita e come ti senti contano più del raggiungere il numero di una formula.`)
};

const pt_br2_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trate como uma referência. Composição corporal, medida da cintura e como você se sente importam mais do que bater o número de uma fórmula.`)
};

const pt_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trate-o como uma referência. A composição corporal, o perímetro da cintura e como se sente importam mais do que atingir o número de uma fórmula.`)
};

const ja_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目安として捉えてください。体組成、ウエストサイズ、体調のほうが、計算式の数値を正確に達成することより重要です。`)
};

const zh_iw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请将其视为参考。身体成分、腰围和自身感觉，比达到某个公式的数值更重要。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_a4", locale)
	if (locale === "en") return en_iw_faq_a4(inputs)
	if (locale === "es") return es_iw_faq_a4(inputs)
	if (locale === "de") return de_iw_faq_a4(inputs)
	if (locale === "nl") return nl_iw_faq_a4(inputs)
	if (locale === "fr") return fr_iw_faq_a4(inputs)
	if (locale === "it") return it_iw_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_a4(inputs)
	if (locale === "pt") return pt_iw_faq_a4(inputs)
	if (locale === "ja") return ja_iw_faq_a4(inputs)
	return zh_iw_faq_a4(inputs)
};